module.exports = __webpack_public_path__ + "img/sonorizacao.b6a822ae.svg";